module.exports = __webpack_public_path__ + "static/media/hourly.351fe682.png";